export default function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_has.js
// module id = 22
// module chunks = 1